import { IDetailPaymentItem } from '../masterdata';

export interface IChartData {
  label: string;
  set: IChartDataItem[];
  caption?: string;
}

export interface IChartDataItem {
  amount: number;
  label: string;
  color: string;
  details?: IDetailPaymentItem[];
}

export enum ChartOrientation {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}
